/** Filter vocabulary for current direct study status; no setup or packet lifecycle projection. */
import { shopifyComponentCopy } from '@testfeed/product-language'
export type StudySetupMerchantQueue = 'all' | 'drafts' | 'running' | 'results-ready' | 'errors'

/** Shared filter keys for the direct study status presentation. */
export type StudySetupStatusKey =
  | 'deleting'
  | 'draft'
  | 'prepared'
  | 'preparing'
  | 'queued'
  | 'running'
  | 'complete'
  | 'failed'
  | 'cancelled'
  | 'superseded'
  | 'report-unavailable'
  | 'unknown'

export type StudySetupStatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'critical'

export interface StudySetupStatus {
  key: StudySetupStatusKey
  label: string
  tone: StudySetupStatusTone
}

const statusCopy = shopifyComponentCopy.testsIndex

const STATUS_BY_KEY: Record<StudySetupStatusKey, StudySetupStatus> = {
  deleting: { key: 'deleting', label: shopifyComponentCopy.testsIndex.statusDeleting, tone: 'warning' },
  draft: { key: 'draft', label: statusCopy.statusDraft, tone: 'neutral' },
  prepared: { key: 'prepared', label: statusCopy.statusPrepared, tone: 'neutral' },
  preparing: { key: 'preparing', label: statusCopy.statusPreparing, tone: 'info' },
  queued: { key: 'queued', label: statusCopy.statusQueued, tone: 'info' },
  running: { key: 'running', label: statusCopy.statusRunning, tone: 'info' },
  complete: { key: 'complete', label: statusCopy.statusComplete, tone: 'success' },
  failed: { key: 'failed', label: statusCopy.statusFailed, tone: 'critical' },
  cancelled: { key: 'cancelled', label: statusCopy.statusCancelled, tone: 'neutral' },
  superseded: { key: 'superseded', label: statusCopy.statusSuperseded, tone: 'neutral' },
  'report-unavailable': { key: 'report-unavailable', label: statusCopy.statusReportUnavailable, tone: 'warning' },
  unknown: { key: 'unknown', label: statusCopy.statusUnknown, tone: 'warning' },
}

export function getStudySetupStatusByKey(key: StudySetupStatusKey): StudySetupStatus {
  return STATUS_BY_KEY[key]
}

export function isStudySetupStatusKey(value: string): value is StudySetupStatusKey {
  return Object.hasOwn(STATUS_BY_KEY, value)
}
